import React from 'react';
import PixelButton from "../../components/PixelButton/PixelButton";

const TITLE =
    `
 ▄▀▀▄▀▀▀▄  ▄▀▀█▄▄▄▄  ▄▀▀▀▀▄  ▄▀▀▄ ▄▀▀▄  ▄▀▀▄ ▄▀▄  ▄▀▀█▄▄▄▄ 
█   █   █ ▐  ▄▀   ▐ █ █   ▐ █   █    █ █  █ ▀  █ ▐  ▄▀   ▐ 
▐  █▀▀█▀    █▄▄▄▄▄     ▀▄   ▐  █    █  ▐  █    █   █▄▄▄▄▄  
 ▄▀    █    █    ▌  ▀▄   █    █    █     █    █    █    ▌  
█     █    ▄▀▄▄▄▄    █▀▀▀      ▀▄▄▄▄▀  ▄▀   ▄▀    ▄▀▄▄▄▄   
▐     ▐    █    ▐    ▐                 █    █     █    ▐   
           ▐                           ▐    ▐     ▐        
`

const Resume: React.FC = () => {
    return (
        <div className={"resume-section"} style={{ display: "flex", flexDirection: "column" }}>
            <pre className={"ascii-title"}>
                {TITLE}
            </pre>

            <PixelButton text={"Download resume"} filename={"Awsaf_Fida_Mahmud_Tech_Resume.pdf"} style={{ position:"sticky", top:70 }}></PixelButton>

            <div className={"resume-section"} style={{ marginTop: "20px" }}>
                <embed src="/resume/Awsaf_Fida_Mahmud_Tech_Resume.pdf"
                    style={{ width: "100%", height: "100vh", border: "none" }}
                    width="100%"
                    height="100%"
                ></embed>

            </div>
            {/*<div style={{textAlign: 'center'}}>*/}
            {/*    <h1 style={{marginBottom: "0"}}>Awsaf Fida Mahmud</h1>*/}
            {/*    <div>*/}
            {/*        fidaawsaf@gmail.com | 647-382-3946 | Toronto, ON<br/>*/}
            {/*        <Socials></Socials>*/}
            {/*    </div>*/}
            {/*</div>*/}

            {/*<div className={"two-cols"}>*/}
            {/*    <div style={{flex: 2}}>*/}
            {/*        <div className={"resume-section"}>*/}
            {/*            <h2>Experience</h2>*/}
            {/*            {experiences.map((exp, index) => (*/}
            {/*                <ResumeItem key={index} {...exp} />*/}
            {/*            ))}*/}
            {/*        </div>*/}

            {/*        <div className={"resume-section"}>*/}
            {/*            <h2>Education</h2>*/}
            {/*            {education.map((edu, index) => (*/}
            {/*                <ResumeItem key={index} {...edu} />*/}
            {/*            ))}*/}
            {/*        </div>*/}
            {/*    </div>*/}


            {/*    <div style={{flex: 1}}>*/}
            {/*        <div className={"resume-section"}>*/}
            {/*            <h2>Projects</h2>*/}
            {/*            {projects.map((proj, index) => (*/}
            {/*                <ResumeItem key={index} {...proj} />*/}
            {/*            ))}*/}
            {/*            <Link to={"/portfolio"} style={{color:"lightblue",textDecoration:"underline"}}>See more</Link>*/}

            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}

        </div>);
};

export default Resume;
